import { PATH_IMAGE_URL } from "../../../../../services/api.constant";

export function resolveGallerySrc(imagePath: string): string {
  return `${PATH_IMAGE_URL}${imagePath}`;
}

export function buildImageAlt(
  prefix: string | undefined,
  index: number,
  total: number,
): string {
  const base = prefix?.trim() || "Product";
  return total > 1
    ? `${base} — image ${index + 1} of ${total}`
    : `${base} — product image`;
}
